/// #if PLATFORM === 'xd'
<template>
  <div id="app" :class="isWindows ? 'win' : 'osx'">
    <router-view v-show="!showOnboarding"/>

    <onboarding-updates v-if="showOnboarding" />
  </div>
</template>
/// #else
<template>
  <div id="app">
    <router-view v-show="!showOnboarding"/>

    <onboarding-updates v-if="showOnboarding" />
  </div>
</template>
/// #endif

<script>
import { mapGetters } from 'vuex'
import OnboardingUpdates from '@/components/onboarding/Updates'

export default {
  components: {
    OnboardingUpdates
  },

  computed: {
    ...mapGetters({
      showOnboarding: 'settings/showOnboarding'
    }),
    // eslint-disable-next-line
/// #if PLATFORM === 'xd'
    isWindows () {
      const platform = require('os').platform()
      return platform.match(/^win(.)*/) !== null || false
    }
    // eslint-disable-next-line
/// #endif
  }
}
</script>

<style lang="scss">
/// #if PLATFORM !== 'xd'
@import './src/assets/scss/main.scss';
/// #else
@import './src/assets/scss-xd/main.scss';
    /// #if DEVELOPMENT
    body {
      background-color: #f5f5f5;
    }
    /// #endif
/// #endif
</style>
